<template>
  <div>
    <h3 v-if="showTitle" class="mb-5">
      Lote: <span class="text-primary"> {{ plot.name }}</span> - Producción
      <button title="Editar" class="btn btn-link btn-sm btn-fill btn-wd" @click="showEditForm">
        <i class="fas fa-pen"></i>&nbsp;Editar
      </button>
    </h3>

    <h3 v-else class="mb-4">Datos Producción</h3>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">Fecha de cosecha</p>
        <p v-if="plot.harvest.harvestDate">{{ plot.harvest.harvestDate | date }}</p>
        <p v-else>-</p>
      </div>

      <div class="col-md-6 col-sm-12">
        <p class="h5">Fecha de picado</p>
        <p v-if="plot.harvest.chopDate">{{ plot.harvest.chopDate | date }}</p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">Días a cosecha</p>
        <p v-if="plot.harvest.daysToHarvest">{{ plot.harvest.daysToHarvest }}</p>
        <p v-else>-</p>
      </div>

      <div class="col-md-6 col-sm-12">
        <p class="h5">Días a picado</p>
        <p v-if="plot.harvest.daysToChop">{{ plot.harvest.daysToChop }}</p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">Altura de plantas</p>
        <p v-if="plot.harvest.plantHeight">{{ plot.harvest.plantHeight }}m</p>
        <p v-else>-</p>
      </div>

      <div class="col-md-6 col-sm-12">
        <p class="h5">Inserción de espiga</p>
        <p v-if="plot.harvest.spikeInsertion">{{ plot.harvest.spikeInsertion }}m</p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">¿Inocula?</p>
        <p v-if="plot.harvest.hasInoculation">Si</p>
        <p v-else>-</p>
      </div>
      <div class="col-md-6 col-sm-12">
        <p class="h5">Marca de inoculante</p>
        <p>{{ plot.harvest.inoculantBrand || '-' }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <p class="h5">Rendimiento <span class="text-muted">[Kg/HA]</span></p>
        <p>{{ plot.harvest.storagePerformance || '-' }}</p>
      </div>
      <div class="col-sm-12 col-md-6">
        <p class="h5">Marca máquina picadora</p>
        <p>{{ plot.harvest.chopperMachine || '-' }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <p class="h5">Rendimiento <span class="text-muted">[MV/HA]</span></p>
        <p>{{ plot.harvest.harvestPerformance || '-' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },

    plot: {
      type: Object,
      default: () => null,
    },
  },

  methods: {
    showEditForm() {
      this.$emit('edit');
    },
  },
};
</script>
